/**
 * qiankun 函数封装
 * 1.注册子应用
 * 2.设置默认应用
 * 3.第一个子应用加载完毕回调
 * 4.启动微服务
 */
import {
    registerMicroApps,// 注册子应用方法
    runAfterFirstMounted,// 首个子应用加载完毕回调
    setDefaultMountApp,// 设默认启用的子应用
    start,// 启动qiankun
    addGlobalUncaughtErrorHandler, // 添加全局未捕获异常处理器
    initGlobalState // 官方应用间通信
} from "qiankun";

/**
 * 注册子应用公共方法
 */
function registerAppByUser (apps) {
    //注册子应用
    registerMicroApps(
        apps,
        {
            beforeLoad: [
                app => {
                    console.log('[LifeCycle] before load %c%s', 'color: green;', app.name);
                }
            ],
            beforeMount: [
                app => {
                    console.log('[LifeCycle] before mount %c%s', 'color: green;', app.name);
                }
            ],
            afterUnmount: [
                app => {
                    console.log('[LifeCycle] after unmount %c%s', 'color: green;', app.name);
                }
            ]
        }
    );
}

/**
 * 设置默认子应用
 */
function setDefaultApp (appModuleName) {
    setDefaultMountApp(appModuleName);
}

/**
 * 第一个子应用加载完毕回调
 */
function firstMountedCallback (cb) {
    runAfterFirstMounted(() => {
        cb();
    });
}

/**
 * 启动微服务
 */
function startApp () {
    start({prefetch: false,urlRerouteOnly: true});
}

/**
 * 添加全局未捕获异常处理器
 */
function addErrorHandler () {
    addGlobalUncaughtErrorHandler(event => console.log(event));
}

/**
 * 在主应用注册官方通信方案
 */
function initState () {
    // // 在主应用注册官方通信方案
    // const actions = initGlobalState(msg.state);
    // // 注册消息监听函数
    // actions.onGlobalStateChange((state, prev) => console.log(`主应用应用监听到来自${state.from}发来消息：`, state, prev));

    // 通讯
    const actions = initGlobalState({
        mt: 'init' // 初始化state
    })
    // 在项目中任何需要监听的地方进行监听，在这里监听是为了方便
    actions.onGlobalStateChange((state,prev)=>{
        console.log('main state change',state);
    })
}

export {
    registerAppByUser,
    setDefaultApp,
    firstMountedCallback,
    startApp
};
